import type {Moment} from 'moment';

import {resource} from '@albert-io/json-api-framework/request/builder';
import masqueradeStore from 'generic/Masquerade/Masquerade.store';

// The Clever user query is built by untyped legacy utils; this is the narrow shape
// the dashboard surfaces (home card, Create-New menu) read off the resource.
export interface CleverUser {
  getCleverId: () => string | undefined;
  getDistrictCleverId: () => string | undefined;
  getMeta: () => {
    isAllowCleverSync: () => boolean;
    getLastCleverSyncDate: () => Moment | undefined;
    getCurrentCleverSyncId: () => string | undefined;
  };
}

interface CleverClassSuccessResult {
  success: true;
  classroom_id: string;
  classroom_name: string;
  status: 'created' | 'updated' | 'archived';
}

interface CleverClassErrorResult {
  success: false;
  message: string;
  classroom_name: string;
}

export type CleverClassResult = CleverClassSuccessResult | CleverClassErrorResult;

interface CleverSyncSuccessResults {
  success: true;
  results: CleverClassResult[];
}

interface CleverSyncErrorResults {
  success: false;
  message: string;
}

export type CleverSyncResults = CleverSyncSuccessResults | CleverSyncErrorResults;

export const getUserQuery = () => {
  return resource('user_v2')
    .mandarkEndpoint(['users_v2', masqueradeStore.getUserIdByMasqueradeState()])
    .withMeta('user_v2')
    .customQuery({
      meta: {
        context: {
          user: {
            last_clever_sync_date: true,
            allow_clever_sync: true,
            current_clever_sync_id: true
          }
        }
      }
    });
};
